import { Application } from "@hotwired/stimulus"
import { registerControllers } from '../../shared/scripts/register_controllers.js'

const application = Application.start()
application.debug = false
window.Stimulus = application

const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(controllers)

export { application }
